import create from 'zustand';

interface PaginationState {
  tabPageTimestamps: Record<string, Record<number, string | null>>;
  addTimestamp: (tabId: string, page: number, cursor: string) => void;
  getTimestamp: (tabId: string, page: number) => string | null;
  resetTimestamps: (tabId: string) => void;
  resetAllTimestamps: () => void;
}

const usePaginationStore = create<PaginationState>((set, get) => ({
  tabPageTimestamps: {},

  addTimestamp: (tabId, page, cursor) =>
    set((state) => ({
      tabPageTimestamps: {
        ...state.tabPageTimestamps,
        [tabId]: {
          ...(state.tabPageTimestamps[tabId] || {}),
          [page]: cursor,
        },
      },
    })),

  getTimestamp: (tabId, page) => {
    const { tabPageTimestamps } = get();
    return tabPageTimestamps[tabId]?.[page] || null;
  },

  resetTimestamps: (tabId) =>
    set((state) => ({
      tabPageTimestamps: {
        ...state.tabPageTimestamps,
        [tabId]: {},
      },
    })),

  resetAllTimestamps: () =>
    set(() => ({
      tabPageTimestamps: {},
    })),
}));

export default usePaginationStore;
